// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"3130b546","935":"e1a5b133"}[chunkId] + ".chunk.js";
};